<script setup lang="ts">
import { AppTypography } from '../base';

type SubcategoryOption = {
  id: number;
  label: string;
  product_count?: number;
};

const { categories = [] } = defineProps<{ categories: SubcategoryOption[] }>();

const selection = defineModel<number | null>();

const emit = defineEmits<{ (e: 'selected', id: number): void }>();
</script>

<template>
  <v-chip-group v-model="selection" center-active>
    <v-chip
      v-for="category in categories"
      class="category-chip"
      variant="outlined"
      size="x-large"
      link
      :key="category.id"
      :value="category.id"
      :disabled="category.product_count === 0"
      @click="emit('selected', category.id)"
    >
      <AppTypography element="span" type="subheadline-1" color="-tertiary">
        {{ category.label }}<template v-if="category.product_count !== undefined"> ({{ category.product_count }})</template>
      </AppTypography>
    </v-chip>
  </v-chip-group>
</template>

<style lang="scss" scoped>
.category-chip {
  border-color: rgb(var(--v-theme-stroke));
  height: 32px;
  margin: 0px;
}

:deep(.v-slide-group__content) {
  gap: 8px !important;
}
</style>
